export default {
  account_existed: "Nama Pengguna tidak tersedia.",
  account_not_exists: "Nama Pengguna tidak wujud.",

  invalid_password: "Kata Laluan tidak sah!",
  insufficient_balance: "Baki tidak mencukupi!",

  verify_failed: "Nombor Pengesahan tidak tepat",

  withdrawalAmountMustGreaterThan0: "Jumlah pengeluaran mestilah lebih daripada 0.",
  block: "Akaun anda telah digantung",

  requestTooFrequentAtLeast2Minutes: "Permintaan terlalu kerap. Sila cuba lagi selepas 2 minit.",

  isRequired: "Sila masukkan {fname}.",
  isMinValue: "{fname} mestilah mengandungi sekurang-kurangnya {fvalue}.",
  isMaxValue: "{fname} mestilah lebih kurang daripada atau sama dengan {fvalue}.",
  isMinLength: "{fname} mestilah mengandungi sekurang-kurangnya {fvalue} aksara.",
  isMaxLength: "{fname} mestilah lebih kurang daripada atau sama dengan {fvalue} aksara.",
  isAlpha: "{fname} hanya menerima huruf sahaja.",
  isAlphaNum: "{fname} hanya menerima angka-abjad sahaja.",
  isNumeric: "{fname} hanya menerima angka sahaja.",
  isEmail: "{fname} hanya menerima alamat e-mel yang sah sahaja.",
  isIpAddress: "{fname} hanya menerima alamat IPv4 yang sah sahaja.",
  isSameAs: "{fname} mestilah sepadan dengan {fname2}.",
  isUrl: "{fname} Hanya menerima URLs sahaja.",
  containAlphaNum: "{fname} mestilah mengandungi sekurang-kurangnya satu huruf dan satu angka.",
  selectOption: "Sila pilihkan satu {fname}",
  notSameAs: "{fname} dan {fname2} tidak boleh sama sekali.",
  isBetween: "{fname} mestilah di antara {min} sehingga {max}.",

  invalid_referral_code: "Kod Pengajakan tidak sah",
  accountIdOnlyNumber: "Hanya nilai angka dibenarkan",
  passwordStrengthError: "Kata Laluan mestilah mengandungi  6-20 aksara bersama dengan kombinasi angka dan huruf.",
  tacCodeRequired: "Kod TAC diperlukan",
  invalid_tac: "Kod TAC tidak sah",
  tac_is_valid: "Kod TAC anda sebelum ini masih sah",
  loginFailed: "Tidak dapat Log Masuk",
  loginSucceed: "Berjaya Log Masuk",
  usernameRequired : "Sila masukkan Nama Pengguna",
  passwordRequired : "Sila masukkan Kata Laluan",
  logoutSucceed : "Berjaya Log Keluar",
  logoutFailed : "Tidak dapat Log Keluar",
  requestSucceed: "Permintaan berjaya dihantar",
  requestFailed : "Permintaan gagal dihantar",
  requestProcessing : "Permintaan anda sedang diproses",
  requestDelayed: "Permintaan ditunda",
  verificationCodeRequired: "Pengesahan Kod TAC diperlukan",
  newPasswordRequired: "Kata Laluan Baru diperlukan",
  bankIdRequired: "Sila pilihkan Bank",
  bankNameRequired: "Nama Bank diperlukan",
  bankAccHolderRequired : "Nama Pemegang Akaun Bank diperlukan",
  bankAccNoRequired: "Nombor Akaun Bank diperlukan",
  depositAmountRequired: "Sila masukkan jumlah deposit",
  dateRequired: "Sila pilihkan Tarikh",
  bonusIdRequired: "Sila putuskan pemberian yang dituntut",
  session_not_exists: "Sesi sudah tamat, sila log masuk semula",
  session_expired : 'Sesi tamat tempoh',
  account_inactive: "Nama Pengguna/Akaun tidak aktif",
  account_exists: "ID Akaun/Pengguna telah wujud",
  OK: "Kod TAC telah berjaya dihantar", // for tac code
  ok: "Kod TAC telah berjaya dihantar", // for tac code
  CLOSE: "Akaun anda telah digantung kerana melanggari terma-terma yang terpapar dalam Keadilan Permainan EpicWin",
  close: "Akaun anda telah digantung kerana melanggari terma-terma yang terpapar dalam Keadilan Permainan EpicWin",
  accountIdRequired: 'Sila masukkan Nama Pengguna',
  session_expired : 'Sesi tamat tempoh',

  app_id_required: "ID Permohonan diperlukan",
  permission_denied: "Kebenaran ditolak",
  account_id_required: "ID Akaun/Nama Pengguna diperlukan",
  verification_code_required: "Kod Pengesahan diperlukan",
  account_not_exists: "Nama Pengguna/Akaun tidak wujud",
  verify_failed: "Process Pengesahan gagal",
  parent_account_inactive: "Akaun Induk tidak aktif",
  transfer_id_required: "ID Pindahan diperlukan",
  credit_amount_required: "Jumlah Kredit diperlukan",
  duplicate_credit_record: "Rekod Kredit Pendua ditemui",
  member_wallet_not_exists: "Dompet Ahli tidak wujud",
  debit_amount_required: "Jumlah Debit diperlukan",
  duplicate_debit_record: "Rekod Debit Pendua ditemui",
  result_exists: "Rekod Keputusan telah wujud",
  debit_record_not_found: "Rekod Debit tidak dapat dicari",
  bank_id_required: "ID Bank diperlukan",
  bank_acc_no_required: "Nombor Akaun Bank diperlukan",
  bank_acc_holder_required: "Nama Pemegang Akaun bank diperlukan",
  bank_already_setup: "Akaun Bank telahpun disetkan",
  platform_required: "Platform diperlukan",
  parent_not_exists: "Induk tidak wujud",
  parent_id_required: "ID Induk diperlukan",
  password_required: "Kata Laluan diperlukan",
  contact_phone_required: "Nombor Telefon diperlukan",
  account_exists: "ID Akaun/Pengguna telah wujud",
  vip_mode_not_exists: "Mod VIP tidak wujud",
  ticket_id_required: "ID Tiket diperlukan",
  ref_id_required: "ID Rujukan diperlukan",
  ticket_not_exists: "Tiket tidak wujud",
  ticket_processed: "Tiket telahpun diproses",
  min_deposit_not_met: "Jumlah deposit yang dimasukkan mestilah sekurang-kurangnya senilai dengan jumlah minimum",
  ongoing_promotion: "Anda masih menyertai dalam promosi yang sedang dijalankan. Sila menuntut tawaran bonus yang lain selepas ini",
  invalid_promo_package: "Pakej promosi tidak sah",
  promo_min_deposit_not_met: "Jumlah deposit tidak memenuhi syarat promosi",
  claim_promo_only_once_a_day: "Tawaran promosi hanya boleh dituntut sekali sahaja dalam sehari",
  first_deposit_unmet: "Deposit harian kali pertama telahpun dituntut",
  newbie_unmet: "Ganjaran deposit kpd Pemain Baru telahpun dituntut",
  claim_promo_only_once: "Tawaran promosi ini hanya boleh dituntut sekali sahaja",
  inner_catch: "Kesalahan tidak dijangka",
  systemError: "Kesalahan sistem",
  deposit_amount_required: "Jumlah deposit diperlukan",
  target_bank_id_required: "ID Bank Sasaran diperlukan",
  target_bank_acc_no_required: "Nombor Akaun Bank Sasaran diperlukan",
  target_bank_acc_holder_required: "Nama Pemegang Akaun Bank Sasaran diperlukan",
  deposit_date_required: "Tarikh pendepositan diperlukan",
  deposit_method_required: "Kaedah Deposit diperlukan",
  min_deposit_not_set: "Jumlah Deposit Minimum masih belum ditetapkan",
  min_balance_not_set: "Baki sedia ada minimum masih tidak ditetapkan",
  ibank_account_not_exists: "Akaun IBANK88 tidak wujud",
  ibank_account_inactive: "Akaun IBANK88 tidak aktif",
  withdrawal_amount_required: "Jumlah pengeluaran diperlukan",
  min_withdrawal_not_set: "Jumlah pengeluaran minimum masih belum ditetapkan",
  bank_member_not_exists: "Akaun Bank Ahli Sasaran tidak wujud",
  promotion_requirement_not_met: "Masih tidak memenuhi keperluan promosi",
  invalid_promotion: "Tawaran promosi tidak sah ",
  new_password_required: "Kata Laluan baru diperlukan",
  multiplier_not_found: "Sistem tidak mampu proses permintaan anda pada masa ini, sila cuba sebentar lagi",
  contact_phone_exists: "Nombor telefon telah didaftar",
  BLOCK: "Akaun anda telah digantung",
  tac_expired: "Kod TAC anda telah luput, sila dapatkan Kod TAC baru",
  tac_not_validate: "Kod TAC masih belum disahkan",
  exceed_max_withdrawal: "Lebih daripada jumlah Pengeluaran maksimum",
  bank_member_inactive: "Bank Pengguna tidak aktif",
  bank_member_exists: "Akaun Bank sudah didaftar",
  never_deposited : "Anda mestilah melakukan sekurang-kurangnya sekali pendepositan sebelum membuat pindahan kepada rakan mainanmu",
  transferAmountMustGreaterThanEqual5: "Jumlah pindahan mestilah senilai dengan atau melebihi daripada RM 5",
  invalid_transfer_amount: "Jumlah pindahan mestilah senilai dengan atau melebihi daripada RM 5",
  // account_not_exists : "akaun tidak wujud"
  permission_denied : "Akaun penerima bukan dari laman web yang sama",
  ongoing_promotion : "Anda masih menyertai dalam promosi yang sedang dijalankan",
  insufficient_balance : "Baki tidak mencukupi",
  transfer_success: "Pindahan berjaya dilakukan",
  sender_id_required: "ID pengirim diperlukan",
  recipient_id_required: "ID penerima diperlukan",
  tac_validated: "Kod TAC masih dalam tempoh sah laku.",
  pending_result_in_game: "Keputusan perlawanan masih belum dimuktamadkan",
  accountIdOnlyNumber: "Hanya untuk nombor telefon sah dan aktif sahaja",
  unfinishgamedetected: "Sila menghabiskan permainan percuma ini sebelum menyusul langkah ini",
  duplicate_review: "Anda telahpun menghantar ulasan sebelum ini",
  exceed_withdrawal_frequency: "Anda telah capai had bilangan pengeluaran harian. (5 kali sehari)",
  requestTooFrequentAtLeast2Minutes: "Permintaan anda sedang diproses",
  invalidPhoneNumberFormat: "Nombor telefon tidak sah",
  gspayUnderMaintenance: "Sistem Dalam Penyelenggaraan",
  affiliate_not_exists: " Kod sekutu tidak sah",
  phoneRequired: 'Sila isi nombor telefon',
  couponeCodeRequired: "Kod Kupon diperlukan",
  coupon_code_required: "Kod Kupon diperlukan",
  coupon_not_available: "Kod Kupon tidak sah",
  contact_email_registered: "Alamat e-mel telah digunakan",
  invalidEmailFormat: "Alamat e-mel tidak sah",
  emailRequired: "Sila masukkan alamat e-mel",
  paymentMethodRequired: "Sila Pilih Kaedah Pembayaran",
  depositMethodRequired: "Sila Pilih Cara Deposit",
  telcoCodeRequired: "Sila pilih telco",
  reloadPinCodeRequired: "Sila isi reload pin"
}